import { InputProps } from 'antd/lib/input';

import { StyledInput } from './styles';

export function UiInput(props: InputProps) {
  return <StyledInput {...props} />;
}
